<template>
  <div class="wrap">
    <!-- 顶部Banner -->
    <div class="banner">
      <img src="@/assets/image/lunbo/beijing2.png" alt="" style="width: 100%" />
      <div class="biaotowenzi">
        <h2>领先的信息与通信解决方案提供商</h2>
        <br /><br /><br />
        <p>中华科技、创新有成，诚信立业</p>
      </div>
    </div>

    <!-- 导航菜单 -->
    <Nav :nav-items="navItems" @nav-change="handleNavChange" />

    <!-- 动态内容区域 -->
    <transition name="fade" mode="out-in">
      <!-- 设备服务内容 -->
      <div v-if="activeTab === 'device'" key="device" class="content-area">
        <br /><br /><br />
        <div class="bottom-info1beijian">
          <div class="text-section">
            <h1>备件服务</h1>
            <p>电子设备始终不能100%避免发生故障的可能性，但鹏海信息科技的备件服务可以为客户提供5*8第二工作日<br>到场及7*24*4级别备件服务，快速提供符合原厂标准的备件，确保系统及时恢复运行。</p>
          </div>
          <div class="icon-containerbeijian">
            <img src="@/assets/other/element/yuanquan.png" alt="" />
          </div>
          <div class="xiantiao">
            <img src="@/assets/other/element/xiantiao.png" alt="" />
          </div>
        </div>

        <div class="zupingbox">
          <div class="zupng">
            <h1>租赁及外包服务</h1>
            <p>为客户提供设备租赁和运维外包解决方案，帮助企业降低成本、提升效率。</p>
          </div>

          <div class="leasing-container">
            <div class="content-row">
              <div class="text-content">
                <h2>租赁方法</h2>
                <ul>
                  <li><img src="@/assets/other/element/dian.png">短期租赁：适用于临时需求，如项目测试、活动支持</li>
                  <li><img src="@/assets/other/element/dian.png">长期租赁：为长期项目提供设备支持，灵活调整租期，提供运维服务</li>
                  <li><img src="@/assets/other/element/dian.png">按需租赁：根据客户需求定制设备配置和服务内容</li>
                </ul>
              </div>
              <div class="image-content tu1">
                <img src="@/assets/other/element/tu1.png" alt="租赁方法示意图">
              </div>
            </div>

            <div class="content-row reverse">
              <div class="text-content">
                <h2>服务优势</h2>
                <ul>
                  <li><img src="@/assets/other/element/dian.png">通信领域的丰富经验和资质</li>
                  <li><img src="@/assets/other/element/dian.png">厂家认证的专家工程师可以提供专业的技术服务和产品支持</li>
                  <li><img src="@/assets/other/element/dian.png">定期更新设备，避免技术落后</li>
                </ul>
              </div>
              <div class="image-contentjiazhi tu2">
                &nbsp;&nbsp;<img src="@/assets/other/element/tu2.png" alt="服务优势示意图">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 工程师服务内容 -->
      <div v-else-if="activeTab === 'engineer'" key="engineer" class="content-area">
        <div class="bottom-info1">
          <div class="text-section">
            <h1>驻场服务</h1>
          </div>
          <div class="icon-container">
            <img src="@/assets/other/gongchengshi/kapian.jpg" alt="" />
          </div>

          <div class="liaojiebtn">
            <!-- <a href="#" class="anniubtn">了解详情</a> -->
          </div>
        </div>

        <div class="leasing-container" style=" margin-top: 2%;">
          <div class="text-section">
            <h1>实施服务</h1>
          </div>
          <div class="content-row">
            <div class="text-content">
              <ul>
                <li><img
                    src="@/assets/other/element/dian.png">鹏海信息通过标准化的流程、专业的工程师团队和高效的项目<br />&nbsp;&nbsp;&nbsp;管理工具，提供涵盖基础网络架构、无线网络、数据中心等多<br />&nbsp;&nbsp;&nbsp;场景的设备安装调试服务。
                </li>
                <li style="align-items: left; padding-left: 7%;">
                  <img src="@/assets/other/gongchengshi/duoimg.png"
                    style="object-fit: contain; height: 202px;width: 616px;">
                </li>
              </ul>
            </div>
            <div class="image-content tu1">
              <img src="@/assets/other/gongchengshi/you.png" alt="">
            </div>
          </div>

          <div class="content-row reverse">
            <div class="text-content">
              <h2 style="margin-left: 3.5%;">为客户带来的价值</h2>
              <ul>
                <li><img src="@/assets/other/element/dian.png">规范化：采用行业最佳实践，确保项目实施过程规范、可靠，为后续运维与扩展提供稳定的基础。</li>
                <li><img src="@/assets/other/element/dian.png">高效率：通过精细化的项目管理和流程工具，确保项目按时、按预算完成，优化资源配置，减少浪费。</li>
                <li><img src="@/assets/other/element/dian.png">低风险：通过严格的风险管理流程，实施过程中对潜在风险进行识别与监控，确保项目风险降至最低。</li>
              </ul>
            </div>
            <div class="image-content tu2" style="padding-left: 2%;">
              <img src="@/assets/other/gongchengshi/zuo.png" alt="">
            </div>
          </div>
          <!--          <div class="lc">
            <img src="@/assets/other/gongchengshi/shishiliucheng.png" alt="" />
          </div> -->
          <div class="fuwudengji" style="margin-top: 12%;">
            <div class="zupng">
              <h1>实施流程</h1>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/gongchengshi/shishiliucheng.png" style="width: 80%;" />
            </div>
          </div>
        </div>
      </div>

      <!-- 运维服务内容 -->
      <div v-else key="operation" class="content-area">
        <div class="bottom-info1">
          <div class="text-section">
            <h1>设备维保</h1>
            <p>我们提供专业的设备维保服务，确保您的设备始终处于最佳运行状态。凭借经验丰富的工程师团队、快速<br>响应机制和完善的备件库，我们致力于为客户提供高效、可靠的维保解决方案。</p>
          </div>
          <div class="zupngfuwuneirong">
            <h1>服务内容</h1>
            <p>我们为您提供全方位的设备维保服务，涵盖以下内容：</p>
          </div>






          <div class="paixuboxyunwei">
            <div class="service-itemyunqwi top1yunweifuwu">
              <div class="iconyunweifuwu">
                <img src="@/assets/other/yunwei/iocn/1.png" alt="设备搬迁与安装图标">
              </div>
              <div class="contentayunweifuwu">
                <h3>定期巡检与保养</h3>
                <p>定期对设备进行检查和维护，预防潜在<br />故障，延长设备使用寿命</p>
              </div>
            </div>

            <div class="service-itemyunqwi right2yunweifuwu">
              <div class="iconyunweifuwu">
                <img src="@/assets/other/yunwei/iocn/3.png" alt="设备搬迁与安装图标">
              </div>
              <div class="contentayunweifuwu">
                <h3>设备搬迁与安装</h3>
                <p>提供专业的设备搬迁和安装服务，确保<br>设备安全、高效地投入使用</p>
              </div>
            </div>

            <div class="service-itemyunqwi right1yunweifuwu">
              <div class="iconyunweifuwu">
                <img src="@/assets/other/yunwei/iocn/6.png" alt="维保管理">
              </div>
              <div class="contentayunweifuwu">
                <h3>维保管理</h3>
                <p>基于ISO-9001和ITSS，围绕PPTR四要素<br />构建全方位维保体系，简化运营维护管理</p>
              </div>
            </div>

            <div class="service-itemyunqwi left1yunweifuwu">
              <div class="contentayunweifuwu">
                <h3 style="text-align: right;">故障诊断与维修</h3>
                <p style="text-align: right;">快速定位设备故障，提供专业的维修<br />服务，恢复设备正常运行</p>
              </div>
              <div class="iconyunweifuwu">
                <img src="@/assets/other/yunwei/iocn/2.png" alt="维保管理">
              </div>
            </div>

            <div class="service-itemyunqwi left2yunweifuwu">
              <div class="contentayunweifuwu">
                <h3 style="text-align: right;">备件更换与升级</h3>
                <p style="text-align: right;">提供原厂备件更换服务，并根据需求<br />进行设备升级，提升设备性能</p>
              </div>
              <div class="iconyunweifuwu">
                <img src="@/assets/other/yunwei/iocn/5.png" alt="维保管理">
              </div>
            </div>

            <div class="yunweifuwubeijin">
              <img src="@/assets/other/yunwei/yuanimg.png" alt="" />
            </div>
          </div>










          <div class="fuwudengji" style=" margin-top:-5%;">
            <div class="zupng">
              <h1>服务等级</h1>
              <p>我们提供多种服务等级，满足不同客户的需求：</p>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/yunwei/fuwudengji.jpg" />
            </div>
          </div>

          <div class="fuwudengji" style=" margin-top: 11.5%;">
            <div class="zupng">
              <h1>故障等级</h1>
              <p>根据故障的紧急程度和影响范围，我们将故障分为以下等级：</p>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/yunwei/guzhan.jpg" />
            </div>
          </div>

          <div class="fuwudengji" style=" margin-top: 8%;">
            <div class="zupng">
              <h1>故障处理流程</h1>
              <p>我们的故障处理流程高效透明，确保您的设备问题得到快速解决：</p>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/yunwei/chuli.jpg" />
            </div>
          </div>

          <br />
          <div class="liaojiebtn">
            <!-- <a href="#" class="anniubtn">联系我们</a> -->
          </div>
        </div>

        <div class="bottom-info1" style=" margin-top: 3%;">
          <div class="text-section">
            <h1>管理服务</h1>
          </div>
        </div>

        <div class="zupingbox" style=" margin-top: 1%;">
          <div class="leasing-container">
            <div class="content-row">
              <div class="text-content">
                <h2>服务介绍</h2>
                <ul>
                  <li><img src="@/assets/other/element/dian.png">我们为企业提供数字化网络管理服务，保障安全稳定，支撑业务高
                    <br />&nbsp;&nbsp;&nbsp;效运行。通过综合运维方案，助力组建专业团队、搭建智能平台，<br />&nbsp;&nbsp;&nbsp;实现运维标准化、可视化及精细化管理。
                  </li>
                  <li><img
                      src="@/assets/other/element/dian.png">从人员、流程、技术、资源四维度定制方案，结合咨询-培训-部署<br />&nbsp;&nbsp;&nbsp;全流程，提升运维质量与业务连续性。
                  </li>
                </ul>
              </div>
              <div class="image-content tu1">
                <img src="@/assets/other/yunwei/jieshao.jpg" alt="租赁方法示意图">
              </div>
            </div>
          </div>

          <div class="fuwudengji" style=" margin-top: 0%;">
            <div class="zupng">
              <h1>客户价值</h1>
              <p>我们的管理服务确保您的网络系统始终安全、稳定、高效运行，助力企业实现业务目标</p>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/yunwei/kehujiazhi.jpg" />
            </div>
          </div>

          <div class="fuwudengji" style=" margin-top: 8.5%;">
            <div class="zupng">
              <h1>运维服务核心内容如下</h1>
            </div>
            <div class="fuwuimg">
              <img src="@/assets/other/yunwei/hexinneirong.jpg" />
            </div>
          </div>
          <br />
          <div class="liaojiebtn">
            <!-- <a href="#" class="anniubtn">联系我们</a> -->
          </div>
        </div>
      </div>
    </transition>

    <Footer :show="true" />
  </div>
</template>

<script>
  import Nav from "../../components/Nav/Nav.vue";

  export default {
    name: "list",
    components: {
      Nav
    },


    props: {
      tab: { // 接收路由参数
        type: String,
        default: 'device'
      }
    },


    data() {
      return {
        // activeTab: "device", // 默认显示设备服务
        // activeTab: this.tab,
        activeTab: this.$route.params.tab || 'device',
        navItems: [{
            title: "设备服务",
            id: "device"
          },
          {
            title: "工程师服务",
            id: "engineer"
          },
          {
            title: "运维服务",
            id: "operation"
          }
        ]
      };
    },
    watch: {
      '$route'(to) {
        // 更可靠的路由变化监听
        this.activeTab = to.params.tab || 'device';
      }
    },
    methods: {
      handleNavChange(item) {
        this.activeTab = item.id;
        // 使用相同的跳转方式保持一致性
        this.$router.push({
          name: 'wordList',
          params: {
            tab: item.id
          }
        });
      }
    }
    // methods: {
    //     handleNavChange(item) {
    //       // 1. 先更新本地状态确保即时响应
    //       this.activeTab = item.id;

    //       // 2. 使用requestAnimationFrame确保DOM更新后执行
    //       requestAnimationFrame(() => {
    //         // 3. 获取当前滚动位置
    //         const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    //         // 4. 使用replaceState更新URL而不刷新
    //         this.$router.replace({
    //           name: 'wordList',
    //           params: { tab: item.id },
    //           // 5. 添加标记避免滚动行为处理
    //           meta: { noScroll: true }
    //         }).then(() => {
    //           // 6. 恢复滚动位置
    //           window.scrollTo(0, scrollPosition);
    //         });
    //       });
    //     }

    // }
  };
</script>

<style scoped lang="scss">
  * {
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    contain: content;
  }

  .yunweifuwubeijin {
    top: 39.1%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    object-fit: contain;
    display: inline-flex;
    display: grid;
    place-items: center;

  }

  .yunweifuwubeijin img {
    object-fit: contain;
    margin-top: 50px;
    width: 420px;
    height: 420px;
    opacity: 1;
    align-items: center;
    justify-content: center;
    z-index: 5;
  }


  .contentayunweifuwu h3 {
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 28.8px;
    color: rgba(47, 49, 51, 1);
    text-align: left;
  }

  .contentayunweifuwu p {
    margin-top: 2%;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.5px;
    line-height: 24px;
    color: rgba(103, 103, 103, 1);
    text-align: left;
    vertical-align: top;
  }

  .top1yunweifuwu {
    position: absolute;
    transform: translate(50% 50%);
    top: 8.5%;
    left: 47%;
    z-index: 999;
  }



  .left1yunweifuwu {
    position: absolute;
    transform: translate(50% 50%);
    top: 31%;
    left: 11.6%;
    z-index: 999;
  }

  .left2yunweifuwu {
    position: absolute;
    transform: translate(50% 50%);
    top: 56.5%;
    left: 14%;
    z-index: 999;
  }

  .right2yunweifuwu {
    position: absolute;
    transform: translate(50% 50%);
    top: 31%;
    left: 61%;
    z-index: 999;
  }

  .right1yunweifuwu {
    position: absolute;
    transform: translate(50% 50%);
    top: 56.5%;
    left: 57%;
    z-index: 999;
  }

  .paixuboxyunwei {
    position: relative;
    height: 700px;
  }

  .service-itemyunqwi {

    display: flex;
    /* 使用 Flexbox 布局 */
    align-items: center;
    /* 垂直居中对齐 */
    gap: 20px;
    /* 图标和文字之间的间距 */
    margin: 0 auto;
    /* 水平居中 */
    // padding: 15px;          /* 内边距 */
  }

  .iconyunweifuwu img {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }

  .iconyunweifuwu {
    display: flex;
    align-items: center;
    /* 确保图标自身垂直居中 */
    justify-content: center;
  }

  //

  .zupngfuwuneirong {
    margin-top: 50px;

    h1 {
      font-size: 40px;
      font-weight: 500;
      line-height: 80px;
      color: rgba(0, 146, 214, 1);
      text-align: left;
    }

    p {
      font-size: 22px;
      font-weight: 400;
      line-height: 32px;
      color: rgba(103, 106, 108, 1);
      text-align: left;

    }
  }

  .icon-containerbeijian {
    position: absolute;
    transform: translate(50% 50%);
    left: 26.7%;
    top: 21%;
    display: grid;
    place-items: center;
    z-index: 2;
  }

  .icon-containerbeijian img {
    object-fit: contain;
    width: 717px;
    height: 623px;
    height: auto;
    object-fit: contain;
  }

  .bottom-info1beijian {
    height: 1019px;
    position: relative;
    max-width: 1440px;
    margin: 0 auto;
    padding: 30px;
    font-family: "Microsoft YaHei", sans-serif;
    background-color: #fff;
  }




  .wrap {
    width: 100%;
    position: relative;

    /* 内容切换动画 */
    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }

    .content-area {
      width: 100%;
    }

    .banner {
      width: 100%;
      // height: 588px;
      position: relative;
      overflow: hidden;
      justify-content: center;
      align-items: center;
    }

    .biaotowenzi {
       position: absolute;
        top: 50%;           /* 垂直居中 */
        left: 10%;          /* 水平靠左（可根据需求调整百分比） */
        transform: translateY(-50%); /* 精确垂直居中 */
        color: white;       /* 文字颜色 */
        text-align: left;   /* 文字左对齐 */
        max-width: 80%;     /* 防止文字过长 */
        padding: 20px;      /* 文字内边距 */
        z-index: 2;         /* 确保文字在图片上方 */

      h2 {
        font-size: 70px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 101.36px;
        color: rgba(255, 255, 255, 1.0);
        text-align: left;
        vertical-align: top;
      }

      p {
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 30px;
        color: rgba(255, 255, 255, 1.0);
        text-align: left;
        vertical-align: top;
      }
    }

    .bottom-info1 {
      max-width: 1440px;
      margin: 0 auto;
      padding: 30px;
      font-family: "Microsoft YaHei", sans-serif;
      background-color: #fff;
      margin-top: 5%;
    }

    .text-section h1 {
      margin-bottom: 20px;
      font-size: 44px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 55.5px;
      color: rgba(46, 49, 51, 1);
      text-align: center;
      vertical-align: top;
    }

    .text-section p {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 32px;
      color: rgba(103, 106, 108, 1);
      text-align: center;
      vertical-align: top;
    }

    .icon-container {
      display: grid;
      place-items: center;
      margin: 40px 0;
    }

    .icon-container img {
      object-fit: contain;
      max-width: 100%;
      height: auto;
    }

    /* 设备服务特有样式 */
    .tu1 {
      margin-right: -200px;
    }

    .tu2 {
      margin-left: -30px;
    }

    .tu2fuwuyoushi {
      margin-left: -30px;
    }

    .text-content li {
      text-align: left;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 400;
      letter-spacing: 1.1px;
      line-height: 50px;
      color: rgba(103, 103, 103, 1);
    }

    .leasing-container ul li img {
      width: 10px;
      height: 10px;
      object-fit: contain;
      margin-top: 20px;
      margin-right: 16px;
    }

    .leasing-container {
      // margin-top: 9%;
      max-width: 1440px;
      margin: 0 auto;
      padding: 40px 20px;
    }

    .content-row {
      display: flex;
      align-items: center;
      margin-bottom: 60px;
    }

    .text-content {
      flex: 1;
      padding-right: 40px;
    }


    .image-contentzuping {
      flex: 1;

    }

    .image-content {
      flex: 1;
      margin-top: 20px;
    }

    .image-content img {
      display: flex;
      width: 553.21px;
      height: 418px;
      object-fit: contain;
    }

    .image-contentjiazhi {
      flex: 1;
      margin-top: 20px;
      // margin-left: ;
    }

    .image-contentjiazhi img {
      display: flex;
      width: 553.21px;
      height: 418px;
      object-fit: contain;
    }

    .reverse {
      flex-direction: row-reverse;
    }

    .reverse .text-content {
      padding-right: 0;
      padding-left: 40px;
    }

    .text-content h2 {
      margin-left: 30px;
      font-family: "思源黑体";
      font-size: 40px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 80px;
      color: rgba(0, 146, 214, 1);
      text-align: left;
    }

    ul {
      list-style-type: none;
      padding-left: 0;
    }

    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 15px;
      line-height: 1.6;
      color: #444;
    }

    .zupng h1 {
      padding-top: 50px;
      font-size: 44px;
      font-weight: 700;
      letter-spacing: 0px;
      line-height: 55.5px;
      color: rgba(46, 49, 51, 1);
      text-align: center;
    }

    .zupng p {
      padding-top: 20px;
      font-size: 22px;
      font-weight: 400;
      letter-spacing: 0px;
      line-height: 32px;
      color: rgba(103, 106, 108, 1);
      text-align: center;
    }

    .zupingbox {
      max-width: 1440px;
      margin: 0 auto;
      padding: 30px;
      font-family: "Microsoft YaHei", sans-serif;
      background-color: #fff;
    }

    .xiantiao {
      position: absolute;
      transform: translate(50% 50%);
      top: -10%;
      left: 0%;
      width: 1440px;
      max-width: 1440px;
      margin: 0 auto;
      align-items: center;
      z-index: 1;


      img {
        width: 100%;
        height: auto;

      }
    }

    /* 工程师服务特有样式 */
    .liaojiebtn {
      margin: 40px 0;
      text-align: center;
    }

    .anniubtn:hover {
      background: rgba(218, 41, 28, 1);
      color: white;
    }

    .anniubtn:active {
      transform: scale(0.98);
    }

    .anniubtn {
      white-space: nowrap;
      transition: all 0.3s ease;
      text-decoration: none;
      background-color: white;
      text-align: center;
      margin: 0 auto;
      width: 156px;
      height: 56px;
      border-radius: 9px;
      color: rgba(218, 41, 28, 1);
      border: 1px solid rgba(218, 41, 28, 1);
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 40px;
      font-size: 18px;
      line-height: 32px;
    }

    .lc img {
      width: 100%;
      max-width: 1440px;
      margin: 0 auto;
      display: block;
    }

    /* 运维服务特有样式 */





    .fuwudengji {
      margin: 40px 0;

      .zupng {
        margin-bottom: 20px;

        h1 {
          font-size: 40px;
          font-weight: 500;
          line-height: 80px;
          color: rgba(0, 146, 214, 1);
          text-align: left;
        }

        p {
          font-size: 22px;
          font-weight: 400;
          line-height: 32px;
          color: rgba(103, 106, 108, 1);
          text-align: left;
        }
      }

      .fuwuimg img {
        width: 100%;
        max-width: 1440px;
        margin: 0 auto;
        display: block;
      }
    }

    /* 响应式设计 */
    @media (max-width: 768px) {

      .content-row,
      .reverse {
        flex-direction: column;
      }

      .text-content {
        padding: 0 20px 20px !important;
      }


      .tu1,
      .tu2 {
        margin: 0;
      }

      .service-item {
        position: static !important;
        transform: none !important;
        margin-bottom: 30px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Work/list.vue